import { createFileRoute, notFound } from '@tanstack/react-router';

import { ProductRecordPage } from '@/features/products/ProductRecordPage';

export const Route = createFileRoute('/_app/products/$productId')({
    component: ProductRoute,
});

function ProductRoute() {
    const { productId } = Route.useParams();
    const id = Number(productId);
    // A junk id in the URL is a dead link, not a record: the not-found page says so rather than
    // the record page asking the API about NaN.
    if (!Number.isInteger(id) || id <= 0) {
        throw notFound();
    }
    return <ProductRecordPage productId={id} />;
}
